<template>
  <div id="app" :class="{ 'sidebar-collapsed': sidebarCollapsed, 'sidebar-open': sidebarOpen }">
    <Navbar v-if="useDefaultLayout" @toggle-sidebar="toggleSidebar" />

    <div v-if="useDefaultLayout" class="layout-wrapper">
      <div class="sidebar-overlay" v-if="sidebarOpen" @click="closeSidebar"></div>
      <Sidebar :collapsed="sidebarCollapsed" :open="sidebarOpen" @close="closeSidebar" />
      <main class="main-content">
        <router-view />
      </main>
    </div>

    <div v-else class="no-layout">
      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import Navbar from '@/components/Navbar.vue'
import Sidebar from '@/components/Sidebar.vue'

const route = useRoute()
const sidebarCollapsed = ref(false)
const sidebarOpen = ref(false)
const windowWidth = ref(window.innerWidth)

const useDefaultLayout = computed(() => {
  if (route.meta) return route.meta.layout !== 'empty'
  if (route.fullPath === '/login') return false
  return true
})

const toggleSidebar = () => {
  if (windowWidth.value < 640) {
    sidebarOpen.value = !sidebarOpen.value
  } else {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }
}

const closeSidebar = () => {
  sidebarOpen.value = false
}

const handleResize = () => {
  windowWidth.value = window.innerWidth
  if (windowWidth.value >= 640) {
    sidebarOpen.value = false
  }
}

// Fechar sidebar ao navegar para outra pagina
watch(() => route.fullPath, () => {
  closeSidebar()
})

onMounted(() => window.addEventListener('resize', handleResize))
onUnmounted(() => window.removeEventListener('resize', handleResize))
</script>
